module.exports = __webpack_public_path__ + "img/common-file-stack-alternate.e8b240cd.svg";